/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

// 后台管理系统服务器地址
export const baseUrl = process.env.NODE_ENV==='production' ? process.env.BASE_API : 'http://localhost:9091'
// 系统数据备份还原服务器地址
export const backupBaseUrl = process.env.NODE_ENV==='production' ? process.env.BASE_API : 'http://localhost:8080'
// 后台接口地址

export default {
    baseUrl,
    backupBaseUrl,
}



// WEBPACK FOOTER //
// ./src/utils/global.js